module.exports = __webpack_public_path__ + "static/media/fog.86ac0b4c.jpg";